import { identity } from 'lodash';
import { Node_Type } from 'ricos-schema';
import { DEFAULT_PARAGRAPH_DATA, DEFAULT_HEADING_DATA, DEFAULT_CODE_DATA, DEFAULT_DIVIDER_DATA, DEFAULT_HTML_DATA, DEFAULT_BUTTON_DATA, DEFAULT_MAP_DATA, DEFAULT_POLL_DATA } from './node-builder-methods.js';
import 'ricos-schema/dist/statics/bulleted_list.defaults.json';
import 'ricos-schema/dist/statics/ordered_list.defaults.json';
import '../converters/nodeUtils.js';
import '../ReadonlyNonEmptyArray-7f84e7de.js';
import '../string-7364f4a2.js';
import 'uuid';
import '../utils.js';
import '../converters/generateRandomId.js';
import './builder-utils.js';
import '../Option-17466c11.js';
import '../fp-utils-deb7c029.js';
import './modify.js';
import '../modifier-infra.js';
import '../index-391e9505.js';
import '../ReadonlyRecord-d6259bd1.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setupAbstractContentBuilder = (generateId, textNodeCreator, listNodeCreator, nodeCreator, tableNodeCreator, collapsibleListNodeCreator, methodPrefix = identity) => {
  class RicosContentBuilder {
  }
  const builderApis = {};
  const addMethod = (name, method) => {
    builderApis[methodPrefix(name)] = RicosContentBuilder.prototype[methodPrefix(name)] = method;
  };
  const TextNodes = [
    {
      name: "paragraph",
      type: Node_Type.PARAGRAPH,
      dataT: DEFAULT_PARAGRAPH_DATA
    },
    { name: "heading", type: Node_Type.HEADING, dataT: DEFAULT_HEADING_DATA },
    { name: "code", type: Node_Type.CODE_BLOCK, dataT: DEFAULT_CODE_DATA }
  ];
  const ListNodes = [
    { name: "bulletList", type: Node_Type.BULLETED_LIST },
    { name: "orderedList", type: Node_Type.ORDERED_LIST }
  ];
  const PluginNodes = [
    { name: "divider", type: Node_Type.DIVIDER, dataT: DEFAULT_DIVIDER_DATA },
    { name: "file", type: Node_Type.FILE, dataT: {} },
    { name: "gallery", type: Node_Type.GALLERY, dataT: {} },
    { name: "html", type: Node_Type.HTML, dataT: DEFAULT_HTML_DATA },
    { name: "image", type: Node_Type.IMAGE, dataT: {} },
    { name: "video", type: Node_Type.VIDEO, dataT: {} },
    { name: "appEmbed", type: Node_Type.APP_EMBED, dataT: {} },
    { name: "embed", type: Node_Type.EMBED, dataT: {} },
    {
      name: "linkPreview",
      type: Node_Type.LINK_PREVIEW,
      dataT: {}
    },
    { name: "button", type: Node_Type.BUTTON, dataT: DEFAULT_BUTTON_DATA },
    { name: "gif", type: Node_Type.GIF, dataT: {} },
    { name: "map", type: Node_Type.MAP, dataT: DEFAULT_MAP_DATA },
    { name: "poll", type: Node_Type.POLL, dataT: DEFAULT_POLL_DATA }
  ];
  TextNodes.forEach(
    ({
      name,
      type,
      dataT
    }) => {
      addMethod(name, (_a) => {
        var _b = _a, { data = dataT, text } = _b, rest = __objRest(_b, ["data", "text"]);
        return textNodeCreator(generateId)(__spreadValues({
          text,
          type,
          data
        }, rest));
      });
    }
  );
  ListNodes.forEach(({ name, type }) => {
    addMethod(name, (_a) => {
      var _b = _a, { items, data } = _b, rest = __objRest(_b, ["items", "data"]);
      return listNodeCreator(generateId)(__spreadValues({ items, data, type }, rest));
    });
  });
  PluginNodes.forEach(({ name, type, dataT }) => {
    addMethod(name, (_a) => {
      var _b = _a, { data = dataT } = _b, rest = __objRest(_b, ["data"]);
      return nodeCreator(generateId)(__spreadValues({
        type,
        data
      }, rest));
    });
  });
  Object.entries({
    table: tableNodeCreator,
    collapsibleList: collapsibleListNodeCreator
  }).forEach(([name, method]) => addMethod(name, method(generateId)));
  return builderApis;
};

export { setupAbstractContentBuilder };
//# sourceMappingURL=AbstractContentBuilder.js.map
